import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import CostCenterSelect from '../../../common/forms/select/CostCenterSelect';
import UserSelect from '../../../common/forms/select/UserSelect';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import { EXPENSE_AUTHORIZER_USER_TYPE } from '../../../../config/constants';

export const ExpenseAuthorizerUserForm = ({
  handleSubmit,
  loading,
  saveMode,
  edit,
}) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Usuario" required>
          <Field
            name="userId"
            component={UserSelect}
            type="text"
            placeholder="Usuario"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      {!edit && (
        <FormGroup row>
          <FormItem label="Habilitar como Principal">
            <Label>
              <Field name="principal" component="input" type="checkbox" />{' '}
              Principal
            </Label>
          </FormItem>
        </FormGroup>
      )}

      {edit && (
        <FormGroup row>
          <FormItem label="Tipo de Autorizador" required>
            <Field
              name="authorizerType"
              component={Select}
              options={enumToSelectOptions(EXPENSE_AUTHORIZER_USER_TYPE)}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      )}

      <FormGroup row>
        <FormItem label="Centro de Costos" required>
          <Field
            name="costCenterId"
            component={CostCenterSelect}
            isMulti={saveMode}
            type="text"
            placeholder="Centro de Costos"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.Detraction.getIn(['current', 'activity']).isEmpty(),
});

ExpenseAuthorizerUserForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  saveMode: PropTypes.bool,
  edit: PropTypes.bool,
};

ExpenseAuthorizerUserForm.defaultProps = {
  loading: false,
  saveMode: true,
  edit: false,
};

const formComponent = reduxForm({
  form: 'ExpenseAuthorizerUserForm',
})(ExpenseAuthorizerUserForm);

export default connect(mapStateToProps)(formComponent);
